// src/helpers/analytics.js
// gtag-based analytics helpers. Consent Mode v2 (set up in public/index.html
// and updated from CookieConsentContext) handles whether each event is fully
// attributed or sent in cookieless/modeled form — no per-call consent gating
// needed here. NOTE: the `purchase` event is intentionally NOT exposed: the
// Shopify Google & YouTube channel app owns the purchase conversion.

function safeGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function"
    ? window.gtag
    : null;
}

export function trackAddToCart(item, variationId = 0, quantity = 1) {
  const gtag = safeGtag();
  if (!gtag) return;

  const variation = item?.variations?.[variationId] || {};
  const price = Number(variation.price) || 0;

  gtag("event", "add_to_cart", {
    currency: "EUR",
    value: price * quantity,
    items: [
      {
        item_id: item.id,
        item_name: item.name,
        item_category: item.collection,
        item_variant: variation.colour,
        price: price,
        quantity: quantity,
      },
    ],
  });

  // Meta Pixel — same event, Meta's standard AddToCart schema. Held until
  // consent is granted (see public/index.html). Purchase is intentionally NOT
  // fired here: checkout happens on Shopify, so the Shopify Facebook & Instagram
  // channel owns the Purchase conversion (mirrors the Google/purchase note above).
  if (window.__META_PIXEL_ON && typeof window.fbq === "function") {
    window.fbq("track", "AddToCart", {
      content_ids: [item.id],
      content_name: item.name,
      content_type: "product",
      contents: [{ id: item.id, quantity: quantity }],
      value: price * quantity,
      currency: "EUR",
    });
  }
}
